<template>
  <div class="select-field" :class="[wrapperStyle.class]" :style="[wrapperStyle.style]" :ref="name">
    <div class="featured-image" v-if="displayImage && displayingImages.length < 1">
      <div class="card grey lighten-5 z-depth-0">
        <i class="material-icons">highlight_off</i>
      </div>
      <!--     <div class="bg-element" ref="bgElement"  :style="[{backgroundImage: `url(${displayImage})`}, displayingImage]"></div> -->
    </div>
    <div class="featured row" v-else-if="displayingImages.length > 0 && displayImage">
      <div v-for="(x, a) in displayingImages" :key="a" class="bg-element col s12 m4" ref="bgElement" :style="[{ backgroundImage: `url(${displayImage})` }, x]"></div>
      <div class="clear"></div>
    </div>
    <i class="material-icons prefix" v-if="icon">{{ icon }}</i>
    <div :class="`${name}_select select-labels`" v-if="showLabel">{{ label }}</div>

    <span class="helper-text" :data-error="error" data-success="Correct" v-if="showHelperText">{{ helperText }}</span>

    <div class="wrapped-a-select-field">
      <select
        v-if="!isMultiple"
        :class="[fieldStyle.class, { 'browser-default': browserDefault }]"
        :style="[fieldStyle.style]"
        :id="`${name}_select`"
        :ref="`${name}_select`"
        v-model="fieldValue"
        :disabled="isDisabled"
      >
        <option :value="option.value" v-for="(option, index) in options" :key="index" :disabled="option.default">
          {{ option.text }}
        </option>
      </select>
      <select v-else :class="[fieldStyle.class]" :style="[fieldStyle.style]" :id="`${name}_select`" :ref="`${name}_select`" v-model="fieldValue" multiple>
        <option
          :value="option.value"
          :data-icon="option.image ? option.image : ''"
          v-for="(option, index) in options"
          :key="index"
          :selected="option.default ? (option.default === true ? true : false) : false"
          :disabled="disabledConditions(option) || isDisabled"
        >
          {{ option.text }}
        </option>
      </select>
    </div>
    <div class="display-text" v-if="descriptionText"><i>Tip!</i> <span v-html="descriptionText"></span></div>

    <div class="select-guide" v-if="selectGuide">
      <div class="modal view-options modal-fixed-footer" ref="selectionModal">
        <div class="modal-title" v-if="titleText">
          {{ titleText }}
        </div>
        <div class="modal-content">
          <div class="flex-row">
            <div class="flex-item z-depth-1" v-for="(x, f) in options" :key="(f + 1) * 0.33" v-show="x.image">
              <img class="materialboxed" :data-caption="x.text" :src="x.image" />
              <label>
                <input type="checkbox" :disabled="disabledConditions(x) || isDisabled" v-model="fieldValue" :value="x.value" group="ags" />
                <span class="css"> {{ x.text }}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-flat waves-effect transparent close-modal modal-close grey-text text-darken-3">Close</button>
        </div>
      </div>
      <button @click="selfDestroyingDiv()" class="btn z-depth-0 grey lighten-3 grey-text text-darken-4  waves-effect">
        <i class="material-icons-outlined grey-text text-darken-3 left">insert_photo</i> View Examples
      </button>
    </div>
    <div class="map-guide" v-if="mapGuide">
      <googlemaps-component v-if="openMap" @state="openMap = $event" @distanceUpdate="$_pushUpdate()"></googlemaps-component>
      <button @click="openMap = true" class="btn z-depth-0 grey lighten-3 grey-text text-darken-4  waves-effect">
        <i class="material-icons-outlined grey-text text-darken-3 left">map</i> Open Map
      </button>
    </div>
  </div>
</template>

<script>
import googlemapsComponent from "@/components/googlemaps.component.vue";
import M from "materialize-css";
export default {
  name: "SelectField",
  components: {
    googlemapsComponent,
  },
  props: {
    selectGuide: {
      type: Boolean,
      default: false,
    },
    mapGuide: {
      type: Boolean,
      default: false,
    },
    titleText: {
      type: [String, Boolean],
      default: false,
    },
    descriptionText: {
      type: [String, Boolean],
      default: false,
    },
    disableIf: {
      type: [String, Boolean, Array],
      default: false,
    },
    value: {
      type: [String, Array],
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    fieldType: {
      type: String,
      required: false,
    },
    displayImage: {
      type: [String, Object, Array, Boolean],
      required: false,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    helperText: {
      type: String,
      required: false,
      default: "",
    },
    showHelperText: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      required: false,
    },
    wrapperStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    fieldStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    groupTag: {
      type: String,
      default: "",
    },
    browserDefault: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      required: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
      reuqired: false,
    },
  },
  data() {
    return {
      openMap: false,
      modalInstance: null,
      selectInstances: null,
      isTyping: false,
      fieldValue: this.isMultiple ? [] : "",
    };
  },
  mounted() {
    this.setDefaultValue();

    setTimeout(() => {
      this.$_initSelectField();
    });
    setTimeout(() => {}, 300);
    this.addToGroup();
  },
  beforeDestroy() {
    this.selectInstances ? this.selectInstances.destroy() : false;
  },
  watch: {
    fieldValue: function() {
      this.updateValue();
    },
    disabledIf: function(nV) {
      let findMatchinValue = () => {
        return this.disableIf.filter((x) => {
          if (this.value.includes(x)) return x;
        });
      };
      if (nV) {
        let typeCheck = Array.isArray(this.disableIf);
        this.fieldValue = typeCheck ? findMatchinValue() : [this.disableIf];
      }
      setTimeout(() => {
        this.$_initSelectField();
      }, 100);
      setTimeout(() => {
        /* this.selectInstances.dropdown.open() */
      }, 150);
    },
    /* isDisabled: function() {} */
  },
  computed: {
    displayingImage: {
      get() {
        const theValue = this.options.find((x) => x.value === this.fieldValue);
        return theValue && this.displayImage ? theValue.styles : [];
      },
    },
    disabledIf: {
      get() {
        let typeCheck = Array.isArray(this.disableIf);
        let valueCheck = Array.isArray(this.value);
        if (typeCheck && valueCheck) {
          let defaultState = this.value.map((x) => this.disableIf.indexOf(x));
          return defaultState.some((x) => x > -1);
        } else {
          if (this.disableIf && valueCheck) {
            return this.value.indexOf(this.disableIf) > -1 ? true : false;
          }
          //  return this.disableIf && Array.isArray(this.value) ? this.value.indexOf(this.disableIf) > -1 ? true : false : false
        }
        /*   let typeCheck =  Array.isArray(this.disableIf)
        return typeCheck ? this.disableIf && Array.isArray(this.value) ? this.value.indexOf(this.disableIf) > -1 ? true : false : false
                        : false */
      },
    },
    displayingImages: {
      get() {
        const arrCheck = Array.isArray(this.fieldValue);
        const theValue = arrCheck ? this.fieldValue.map((y) => this.options.find((x) => x.value === y)) : [];
        return theValue.length > 0 && this.displayImage ? theValue.filter((y) => y.styles).map((x) => x.styles) : false;
      },
    },
    // Implement a better error display
    // displayError() {
    //   if (this.isTyping) {
    //     // Add invalid class and remove valid
    //     if (this.hasError && this.error) {
    //       if (this.selectInstances) {
    //         this.$el.querySelector(".select-dropdown").classList.add("invalid");
    //         this.$el
    //           .querySelector(".select-dropdown")
    //           .classList.remove("valid");
    //       }
    //     } else {
    //       if (this.selectInstances) {
    //         this.$el.querySelector(".select-dropdown").classList.add("valid");
    //         this.$el
    //           .querySelector(".select-dropdown")
    //           .classList.remove("invalid");
    //       }
    //     }
    //   }
    // }
  },
  methods: {
    $_pushUpdate() {
      this.openMap = false;
    },
    disabledConditions(o) {
      if (o.default) return true;
      // console.log(o.default)
      /*  disabledIf && disableIf !== option.value ? true : option.default ? (option.default === true ? true : false) : false */
      let willDisable = this.disableIf;
      let typeCheck = Array.isArray(this.disableIf);
      if (willDisable && !typeCheck) {
        return this.disabledIf && this.disableIf !== o.value ? true : o.default ? (o.default === true ? true : false) : false;
      } else if (willDisable && typeCheck) {
        return this.disabledIf && this.fieldValue.indexOf(o.value) < 0 ? true : o.default ? (o.default === true ? true : false) : false;
      } else {
        o.default ? true : false;
      }
    },
    $_getMyDetails(v) {
      const test = this.options.find((x) => x.value === this.fieldValue);

      return test && test.styles ? test.styles.backgroundPosition.toString() : "";
    },
    selfDestroyingDiv() {
      const killMe = (e) => {
        this.modalInstance.destroy();
        this.$_initSelectField();
      };
      const clickMe = () => {
        let elems = document.querySelectorAll(".materialboxed");
        let instances = M.Materialbox.init(elems, {});
      };
      this.modalInstance = window.M.Modal.init(this.$refs.selectionModal, {
        onCloseEnd: killMe,
        onOpenEnd: clickMe,
      });
      this.modalInstance.open();
    },
    addToGroup() {
      if (this.groupTag) {
        const groupId = `#${this.groupTag}`;
        const contentContainerId = `#${this.groupTag}_content`;
        // console.log(`${this.name} => belongs to ${this.groupTag} group`);

        const group = document.querySelector(groupId);

        const contentContainer = document.querySelector(contentContainerId);

        const groupItem = this.$refs[this.name];

        if (contentContainer) {
          contentContainer.appendChild(groupItem);
        } else {
          group.appendChild(groupItem);
        }
      }
    },
    setDefaultValue() {
      if (this.isMultiple) {
        if (!this.value) {
          this.fieldValue = [];
        } else {
          this.fieldValue = this.value;
        }
      } else {
        if (!this.value) {
          if (this.value === null) {
            this.fieldValue = this.value;
          } else this.fieldValue = "";
        } else {
          this.fieldValue = this.value;
        }
      }
    },
    updateValue() {
      this.$emit("update", this.fieldValue);
      if (this.browserDefault) return;
      setTimeout(() => {
        !this.isMultiple ? this.selectInstances.dropdown.close() : false;
      }, 90);
    },
    $_initSelectField() {
      if (this.browserDefault) return;
      const elem = this.$refs[`${this.name}_select`];
      // console.log(elem);
      const options = {
        dropdownOptions: {
          closeOnClick: false,
        },
      };
      this.selectInstances = M.FormSelect.init(elem, options);
    },
  },
};
</script>

<style lang="scss" scoped>
.featured-image {
  height: 180px;
  width: 100%;

  .bg-element {
    position: absolute;
    left: 25%;
    right: 0;
    bottom: 0;
    height: 170px;
    background-repeat: no-repeat;
    width: 170px;
    /* background-position: ; */
  }
}
.featured {
  /*     height: 180px; */
  width: 100%;
  position: relative;
  overflow: hidden;
  overflow-x: scroll;
  display: flex;
  position: relative;
  .bg-element {
    float: left;
    margin-right: 8px;
    height: 170px;
    margin: auto;
    background-repeat: no-repeat;
    width: 170px;
    min-width: 170px;
    /* background-position: ; */
  }
}
.select-field {
  margin-bottom: 12px;
  position: relative;
  .select-labels {
    font-size: 20px;
    margin-bottom: 12px;
  }
  select {
    margin-bottom: 6px;
    font-size: 16px;
  }
}
.flex-row {
  display: flex;
  flex-wrap: wrap;
  .flex-item {
    width: calc(33.3% - 16px);
    float: left;
    background: white;
    border-radius: 6px;
    margin: 0 8px 16px;
    @media screen and (max-width: 768px) {
      width: calc(50% - 16px);
    }
    img {
      width: 100%;
    }
  }
}
.view-options {
  &.modal {
    min-height: 80%;
    @media screen and (max-width: 768px) {
      top: 56px !important;
      width: 90% !important;
      min-height: calc(100% - 145px) !important;
    }
    border-radius: 8px;

    .modal-title {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      height: 56px;
      line-height: 56px;
      z-index: 99;
      padding: 0px 12px;
      background: white;
      font-size: 18px;
    }
    .modal-content {
      padding-top: 66px;
    }
  }
}
.display-text {
  font-style: italic;
}
.helper-text {
  margin: 0 0 12px 0px;
  font-size: 15px;
}
</style>
<style lang="scss">
.materialbox-caption {
  z-index: 1005;
}

.wrapped-a-select-field {
  padding: 2px 5px 2px;
  border: 1px solid lightgrey;
  border-radius: 5px;
  margin-bottom: 10px;
  select,
  input {
    border: none !important;
    margin: 0 !important;
  }
}
span.css {
  margin: 9px 0 12px 12px !important;
  line-height: 1.5 !important;
  padding-left: 25px !important;
  padding-bottom: 5px;
  display: inline-table !important;
}
.multiple-select-dropdown {
  li {
    span {
      width: calc(100% - 60px) !important;
      label {
        span {
          line-height: 1.4 !important;
        }
      }
    }
  }
}
</style>
